import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const SidebarLink = styled(Link)`
  display: flex;
  color: rgba(255, 255, 255, 0.85);
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  list-style: none;
  min-height: 50px;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 3px solid transparent;
  position: relative;
  margin: 2px 8px;
  border-radius: 8px;

  & svg {
    font-size: 20px;
    transition: all 0.3s ease;
  }

  &:hover {
    background: rgba(58, 107, 126, 0.15);
    border-left: 3px solid #3A6B7E;
    color: #fff;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    
    & svg {
      transform: scale(1.1);
      color: #3A6B7E;
    }
  }

  &.active {
    background: rgba(58, 107, 126, 0.25);
    border-left: 3px solid #3A6B7E;
    color: #fff;
    box-shadow: 0 2px 12px rgba(58, 107, 126, 0.2);
    
    & svg {
      color: #3A6B7E;
    }
  }
`;

const SidebarLabel = styled.span`
  margin-left: 14px;
  font-weight: 500;
  flex: 1;
  letter-spacing: 0.3px;
`;

const DropdownContainer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 2px solid rgba(58, 107, 126, 0.3);
  margin-left: 12px;
  margin-right: 8px;
  border-radius: 0 8px 8px 0;
  overflow: hidden;
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 500px;
    }
  }
`;

const DropdownLink = styled(Link)`
  min-height: 44px;
  padding: 12px 20px 12px 3.5rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border-radius: 6px;
  margin: 2px 8px;

  & svg {
    font-size: 18px;
    margin-right: 12px;
    transition: all 0.3s ease;
  }

  &:hover {
    background: rgba(58, 107, 126, 0.2);
    color: #fff;
    transform: translateX(4px);
    padding-left: 3.8rem;
    
    & svg {
      transform: scale(1.1);
      color: #3A6B7E;
    }
  }

  &.active {
    background: rgba(58, 107, 126, 0.25);
    color: #fff;
    border-left: 2px solid #3A6B7E;
    
    & svg {
      color: #3A6B7E;
    }
  }
`;

const SubMenu = ({ item, closeSidebar }) => {
  const [subnav, setSubnav] = useState(false);
  const location = useLocation();

  const showSubnav = (e) => {
    // Solo abrir/cerrar si tiene subNav
    if (item.subNav) {
      e.preventDefault();
      setSubnav(!subnav);
    } else if (closeSidebar) {
      closeSidebar();
    }
  };

  // Verificar si algún subItem está activo
  const isSubItemActive = item.subNav?.some(subItem => 
    subItem.path && location.pathname === subItem.path
  );

  // Verificar si el item principal está activo
  const isActive = item.path && location.pathname === item.path;

  return (
    <>
      <SidebarLink 
        to={item.path || "#"} 
        onClick={showSubnav}
        className={isActive || isSubItemActive ? 'active' : ''}
      >
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {item.subNav && (subnav ? item.iconOpened : item.iconClosed)}
        </div>
      </SidebarLink>
      {subnav && item.subNav && (
        <DropdownContainer>
          {item.subNav.map((subItem, index) =>
            subItem.subNav ? (
              // Llamada recursiva para submenús anidados
              <SubMenu item={subItem} key={index} closeSidebar={closeSidebar} />
            ) : (
              <DropdownLink
                to={subItem.path}
                key={index}
                onClick={closeSidebar}
                className={location.pathname === subItem.path ? 'active' : ''}
              >
                {subItem.icon}
                <SidebarLabel>{subItem.title}</SidebarLabel>
              </DropdownLink>
            )
          )}
        </DropdownContainer>
      )}
    </>
  );
};

export default SubMenu;